import { useNavigate } from 'react-router-dom';
import { Activity, KeyRound, LogOut, UserCog } from 'lucide-react';
import { Avatar, Menu } from '@castinflow/ui';
import type { MeResponse } from '@castinflow/shared';
import { ROLE_LABEL, tr } from '../i18n/tr';
import { integrationsText } from '../framework/integrations/integrations-strings';
import { settingsNavText } from '../framework/settings/settings-nav-strings';

export function UserMenu({ me, onLogout }: { me: MeResponse; onLogout: () => void }) {
  const nav = useNavigate();
  const name = `${me.user.firstName} ${me.user.lastName}`.trim();
  return (
    <Menu
      label={tr.shell.userMenu(name)}
      triggerTestId="nav-user"
      // Tema uyarlaması: kullanıcı çipi — avatar + ad + rol (≥ md); telefonda yalnız avatar (dokunma hedefi 44)
      triggerClassName="h-control min-w-control rounded-pill py-1 pl-1 pr-1 transition-colors duration-fast hover:bg-surface md:pr-3"
      trigger={
        <>
          <Avatar name={name} decorative />
          <span className="hidden min-w-0 max-w-[11rem] text-left leading-tight md:block">
            <span className="block truncate text-base font-semibold text-fg">{name}</span>
            <span className="block truncate text-xs text-fg-muted">{ROLE_LABEL[me.user.role]}</span>
          </span>
        </>
      }
      header={
        <div className="min-w-0">
          <p className="truncate text-base font-medium text-fg">{name}</p>
          <p className="truncate text-sm text-fg-subtle">{me.user.email}</p>
          <p className="mt-1 truncate text-sm text-fg-muted">
            {ROLE_LABEL[me.user.role]} · {me.tenant.name}
          </p>
        </div>
      }
      items={[
        {
          // M6 WP 6.2: profil, parola, iki adımlı doğrulama, passkey, oturumlar, bildirim tercihleri
          id: 'account',
          label: settingsNavText.account,
          icon: <UserCog size={16} />,
          onSelect: () => {
            nav('/account');
          },
          testId: 'nav-account',
        },
        {
          id: 'status',
          label: tr.shell.systemStatus,
          icon: <Activity size={16} />,
          onSelect: () => {
            nav('/status');
          },
          testId: 'nav-status',
        },
        {
          // M5 WP 5.5: kendi kullanıcı kaydı › API anahtarı
          id: 'api-keys',
          label: integrationsText.nav.myApiKeys,
          icon: <KeyRound size={16} />,
          onSelect: () => {
            nav(`/users/${me.user.id}`);
          },
          testId: 'nav-my-api-keys',
        },
        {
          id: 'logout',
          label: tr.shell.logout,
          icon: <LogOut size={16} />,
          onSelect: onLogout,
          testId: 'nav-logout',
        },
      ]}
    />
  );
}
